import {setViewProductsPageInfo, setCategoryById, resetOffset} from "./Functions/Helpers";
import React from "react";
import {WooContext} from "./WooContext";
import LoadSpinner from "./Elements/LoadSpinner";
import {allProductsUrl} from "./Elements/consts";
import SvgLink from "./SVG";
import {ICON_DOWN_ARROW} from './SVG/consts';

function ProductCategories(productCategories) {
    const {currentCategoryState, pagedState, pageInfoState, currentSectorState, currentBrandState} = React.useContext(WooContext);
    const [currentCategory, setCurrentCategory] = currentCategoryState;
    const [,setCurrentBrand] = currentBrandState;
    const [,setCurrentSector] = currentSectorState;
    const [,setPageInfo] = pageInfoState;
    const [,setPaged] = pagedState;
    return (
        <>
        {productCategories.loading && <LoadSpinner/>}
        {productCategories.data && <ul className="product-categories">
            {currentCategory.databaseId > 0 &&
            <li className="back-link">
                <a href={allProductsUrl} onClick={(e) => {
                    e.preventDefault();
                    setViewProductsPageInfo();
                    setCurrentCategory({databaseId:0});
                    setCurrentSector({databaseId:0});
                    setCurrentBrand({databaseId:0});
                    setPageInfo({databaseId:0});
                }}>
                    <span>
                        <span className="back-link-icon">
                             <SvgLink {...ICON_DOWN_ARROW}/>
                        </span>
                        All Products
                    </span>
                </a>
            </li>}
            {productCategories.data.productCategories.nodes.filter(categoryItem => categoryItem.parent === null).map((categoryItem, index) => (
                <li key={index} className={categoryItem.databaseId === currentCategory.databaseId ? 'active': ''}>
                    <a href={categoryItem.uri} onClick={(e) => {
                        e.preventDefault();
                        setCurrentCategory(categoryItem);
                        setPageInfo(categoryItem);
                        resetOffset(setPaged);
                    }}>
                        <span>
                            {categoryItem.name} ({categoryItem.count})
                        </span>
                    </a>
                    {categoryItem.children && (categoryItem.databaseId === currentCategory.databaseId || (currentCategory.parent && currentCategory.parent.node.databaseId === categoryItem.databaseId)) && <ul>
                        {categoryItem.children.nodes.map((categoryItem, index) => (
                            <li key={index}
                                className={categoryItem.databaseId === currentCategory.databaseId ? 'active' : ''}>
                                <a href={categoryItem.uri} onClick={(e) => {
                                    e.preventDefault();
                                    setCurrentCategory(setCategoryById(categoryItem.databaseId, productCategories));
                                    setPageInfo(categoryItem);
                                    resetOffset(setPaged);
                                }}>
                                    <span>
                                        {categoryItem.name} ({categoryItem.count})
                                    </span>
                                </a>
                            </li>
                        ))}
                    </ul>}
                </li>
            ))}
        </ul>}
    </>
    );
}

export default ProductCategories;